export default "__VITE_ASSET__X4PFs9ER__"